import React, { useState, useEffect, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { Select, DatePicker } from "antd";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "../../cssFiles/Report.css";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import {
  dateFormat,
  formatAmount,
  getRestoLogin,
  getRole,
} from "../../Helpers/Utils/Common";
import { useNavigate } from "react-router-dom";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";
import moment from "moment";
// import { useReactToPrint } from "react-to-print";
import ReactLoading from "react-loading";

const { RangePicker } = DatePicker;
function RestoItemSalesReport() {
  const role = getRole();
  const dateToday = moment().format("YYYY-MM-DD");
  const [restoType, setRestoType] = useState(getRestoLogin());
  const navigate = useNavigate();
  const [inactive, setInactive] = useState(true);
  // const [openPDF, setOpenPDF] = useState(false);
  const [filter, setFilter] = useState({
    date_from: new Date().toLocaleDateString("en-CA"),
    date_to: new Date().toLocaleDateString("en-CA"),
    menu_location: restoType,
  });
  const [briqueData, setBriqueData] = useState({});
  const [ettasData, setEttasData] = useState({});
  const [totalSummary, setTotalSummary] = useState({});
  const pdfRef = useRef();
  const [showLoader, setShowLoader] = useState(true);

  // CONTINUOIS PAGE
  const handlePdf = (e) => {
    const content = pdfRef.current;
  
    html2canvas(content, { scale: 1.2 }).then((canvas) => {
      const pageWidth = 210; // A4 size width in mm
      const pageHeight = 297; // A4 size height in mm
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
      let heightLeft = imgHeight;
      let position = 0;
  
      // Create a new jsPDF instance with standard page size
      const pdf = new jsPDF({
        orientation: "p", // 'p' for portrait
        unit: "mm",
        format: [pageWidth, pageHeight] // Standard A4 size
      });
  
      while (heightLeft > 0) {
        // Calculate the height of the section to be added
        const sectionHeight = Math.min(pageHeight, heightLeft);
  
        // Create a new canvas to slice the current section of the image
        const canvasSection = document.createElement('canvas');
        const ctx = canvasSection.getContext('2d');
        canvasSection.width = canvas.width;
        canvasSection.height = sectionHeight * (canvas.width / imgWidth);
  
        // Draw the section of the image on the new canvas
        ctx.drawImage(
          canvas,
          0,
          position * (canvas.width / imgWidth),
          canvas.width,
          sectionHeight * (canvas.width / imgWidth),
          0,
          0,
          canvasSection.width,
          canvasSection.height
        );
  
        const imgSectionData = canvasSection.toDataURL("image/png");
  
        if (position > 0) {
          pdf.addPage();
        }
  
        // Add the image section to the PDF
        pdf.addImage(imgSectionData, "PNG", 0, 0, pageWidth, sectionHeight);
  
        heightLeft -= sectionHeight;
        position += sectionHeight;
      }
  
      // Save the PDF
      pdf.save("Resto_Item_Sales_Report.pdf");
    });
  };
  
  async function fetchReportData() {
    setShowLoader(true);
    filter.menu_location = restoType === "" ? null : restoType;
    const response = await UseGetRequest(
      "reports/brique_ettas",
      filter,
      "happyhippos"
    );
    if (response.data) {
      const tempBriqueData = response.data.data?.brique_data;
      const tempEttasData = response.data.data?.ettas_data;
      const tempSummary = {
        brique_brique_data_qty: (tempBriqueData?.brique_data || []).reduce(
          (a, b) => a + parseInt(b.total_qty),
          0
        ),
        brique_brique_data_total: (tempBriqueData?.brique_data || []).reduce(
          (a, b) => a + parseFloat(b.total_sales),
          0
        ),
        brique_ettas_data_qty: (tempBriqueData?.ettas_data || []).reduce(
          (a, b) => a + parseInt(b.total_qty),
          0
        ),
        brique_ettas_data_total: (tempBriqueData?.ettas_data || []).reduce(
          (a, b) => a + parseFloat(b.total_sales),
          0
        ),
        ettas_brique_data_qty: (tempEttasData?.brique_data || []).reduce(
          (a, b) => a + parseInt(b.total_qty),
          0
        ),
        ettas_brique_data_total: (tempEttasData?.brique_data || []).reduce(
          (a, b) => a + parseFloat(b.total_sales),
          0
        ),
        ettas_ettas_data_qty: (tempEttasData?.ettas_data || []).reduce(
          (a, b) => a + parseInt(b.total_qty),
          0
        ),
        ettas_ettas_data_total: (tempEttasData?.ettas_data || []).reduce(
          (a, b) => a + parseFloat(b.total_sales),
          0
        ),
      };
      setBriqueData(response.data.data?.brique_data);
      setEttasData(response.data.data?.ettas_data);
      setTotalSummary(tempSummary);
      setShowLoader(false);
    } else {
      setEttasData({});
      setBriqueData({});
      setShowLoader(false);
    }
  }

  const csvRef = useRef();

  function handleToCSV() {
    return (
      <DownloadTableExcel
        sheet="users"
        currentTableRef={csvRef.current}
        filename="Resto_Item_Sales_Report"
      >
        <button className=" category-new-export-btn">Export Excel</button>
      </DownloadTableExcel>
    );
  }

  useEffect(() => {
    fetchReportData();
  }, [filter, restoType]);

  useEffect(() => {}, [restoType]);

  // useEffect(() => {
  //   if (openPDF) {
  //     handleExportPDF("pdf-1");
  //   } else {
  //     setOpenPDF(false);
  //   }
  // }, [openPDF]);

  const formatNumberWithCommas = (number) => {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  };

  let globalItemIndex = 5;

  return (
    <div>
      <NavbarAdmin
        onCollapse={(inactive) => {
          setInactive(inactive);
        }}
        active={"Reports"}
        page={"Reports"}
      />
      <div
        className={`container bold-font  ${
          getRole() === "" ? "cashier" : inactive ? "inactive" : "active"
        }`}
      >
        <Row>
          <Col xs={8}>
            <label className="page-title-menu">RESTO ITEM SALES REPORT</label>
          </Col>
          <Col className="">
            <Row>
              <Col>
                <button
                  className="category-new-export-btn"
                  value="pdf-1"
                  // onClick={handleExportPDF}
                  onClick={() => {
                    handlePdf(null, () => pdfRef.current);
                  }}
                >
                  Export PDF
                </button>
              </Col>
              &nbsp;&nbsp;
              {(role === "1" || role === "7") && <Col>{handleToCSV()}</Col>}
              {role === "2" && (
                <Col>
                  <button
                    className="category-new-export-btn"
                    value="pdf-1"
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
        <Row className="">
          <Row className="pt-3 PO-filters">
            <Col xs={3}>
              <RangePicker
                onChange={(e) => {
                  if (e) {
                    setFilter((prev) => ({
                      ...prev,
                      date_from: e[0].format("YYYY-MM-DD"),
                      date_to: e[1].format("YYYY-MM-DD"),
                    }));
                  } else {
                    setFilter((prev) => ({
                      ...prev,
                      date_from: dateToday,
                      date_to: dateToday,
                    }));
                  }
                }}
                placeholder={[dateToday, dateToday]}
                className="w-100 h-100"
              />
            </Col>
            <Col xs={3} className="cat-container">
              <Select
                placeholder="Select restaurant"
                options={[
                  { value: "", label: "All" },
                  { value: "happyhippos", label: "happyhippos" },
                  // { value: "ettas", label: "ETTAS" },
                ]}
                onChange={(e) => setRestoType(e)}
                defaultValue={restoType}
                className="h-100"
              />
            </Col>
          </Row>
          <Row className="mt-3 resto-item-report-container" ref={pdfRef}>
            <div className="">
              <Row className="">
                <label className="print-text d-flex justify-content-center">
                  {getRestoLogin()?.toUpperCase()}
                </label>
              </Row>
              <Row className="">
                <label className="print-text d-flex justify-content-center">
                  {window.company_address}
                </label>
              </Row>
              <Row className="">
                <label className="print-text d-flex justify-content-center">
                  DATE: {`${filter.date_from} - ${filter.date_to}`}
                </label>
              </Row>
              <Row className="">
                <strong className="d-flex justify-content-center">
                  RESTO ITEM SALES REPORT
                </strong>
              </Row>
              <hr />
            </div>
            {showLoader ? (
              <div className="me-3 d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="var(--tertiary-color)"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <div>
                {(filter.menu_location === "ettas" ||
                  filter.menu_location === "" ||
                  !filter.menu_location) && (
                  <div>
                    <Row>
                      <Col xs={7}>
                        <strong>Ettas Item Sales</strong>
                      </Col>
                      <Col xs={2} className="d-flex justify-content-center">
                        <strong>
                          {formatNumberWithCommas(
                            ettasData?.ettas_item_sales?.qty
                          )}
                        </strong>
                      </Col>
                      <Col xs={3} className="text-end">
                        <strong>
                          {formatAmount(
                            ettasData?.ettas_item_sales?.grand_total ?? 0
                          )}
                        </strong>
                      </Col>
                    </Row>

                    {ettasData &&
                    ettasData.ettas_data &&
                    ettasData.ettas_data.length > 0 ? (
                      <>
                        <Row className="mt-2">
                          <Col xs={7} className="padding-left-5 print-text">
                            <strong>Ettas</strong>
                          </Col>
                          <Col
                            xs={2}
                            className="d-flex justify-content-center print-text"
                          >
                            <strong>
                              {formatNumberWithCommas(
                                totalSummary.ettas_ettas_data_qty
                              )}
                            </strong>
                          </Col>
                          <Col xs={3} className="text-end print-text">
                            <strong>
                              {formatAmount(
                                totalSummary.ettas_ettas_data_total
                              )}
                            </strong>
                          </Col>
                        </Row>

                        {ettasData &&
                          ettasData.ettas_data &&
                          ettasData.ettas_data.map((item, index) => {
                            if (index === 0) {
                              globalItemIndex += 4;
                            } else {
                              globalItemIndex += 1;
                            }

                            return (
                              <React.Fragment key={item.name}>
                                {/* {globalItemIndex % 67 === 0 && <br />} */}
                                <Row>
                                  <Col
                                    xs={7}
                                    className="padding-left-7 print-text"
                                  >
                                    {item.name}
                                  </Col>
                                  <Col
                                    xs={2}
                                    className="d-flex justify-content-center print-text"
                                  >
                                    {formatNumberWithCommas(item.total_qty)}
                                  </Col>
                                  <Col xs={3} className="text-end print-text">
                                    {formatAmount(item.total_sales)}
                                  </Col>
                                </Row>
                              </React.Fragment>
                            );
                          })}
                      </>
                    ) : (
                      <Row className="d-flex justify-content-center"></Row>
                    )}

                    {ettasData &&
                    ettasData.brique_data &&
                    ettasData.brique_data.length > 0 ? (
                      <>
                        <Row className="mt-2">
                          <Col xs={7} className="padding-left-5 print-text">
                            <strong>Brique</strong>
                          </Col>
                          <Col
                            xs={2}
                            className="d-flex justify-content-center print-text"
                          >
                            <strong>
                              {formatNumberWithCommas(
                                totalSummary.ettas_brique_data_qty
                              )}
                            </strong>
                          </Col>
                          <Col xs={3} className="text-end print-text">
                            <strong>
                              {formatAmount(
                                totalSummary.ettas_brique_data_total
                              )}
                            </strong>
                          </Col>
                        </Row>
                        {ettasData &&
                          ettasData.brique_data &&
                          ettasData.brique_data.map((item, index) => {
                            if (index === 0) {
                              globalItemIndex += 2;
                            } else {
                              globalItemIndex += 1;
                            }

                            return (
                              <React.Fragment key={item.name}>
                                {/* {globalItemIndex % 67 === 0 && <br />} */}
                                <Row>
                                  <Col
                                    xs={7}
                                    className="padding-left-7 print-text"
                                  >
                                    {item.name}
                                  </Col>
                                  <Col
                                    xs={2}
                                    className="d-flex justify-content-center print-text"
                                  >
                                    {formatNumberWithCommas(item.total_qty)}
                                  </Col>
                                  <Col xs={3} className="text-end print-text">
                                    {formatAmount(item.total_sales)}
                                  </Col>
                                </Row>
                              </React.Fragment>
                            );
                          })}
                      </>
                    ) : (
                      <Row className="d-flex justify-content-center "></Row>
                    )}
                  </div>
                )}
                {(filter.menu_location === "happyhippos" ||
                  filter.menu_location === "" ||
                  !filter.menu_location) && (
                  <div className="">
                    <Row className="mt-2">
                      <Col xs={7}>
                        <strong>Brique Item Sales</strong>
                      </Col>
                      <Col xs={2} className="d-flex justify-content-center ">
                        <strong>
                          {formatNumberWithCommas(
                            briqueData?.brique_item_sales?.qty
                          )}
                        </strong>
                      </Col>
                      <Col xs={3} className="text-end ">
                        <strong>
                          {formatAmount(
                            briqueData?.brique_item_sales?.grand_total ?? 0
                          )}
                        </strong>
                      </Col>
                    </Row>
                    {briqueData &&
                    briqueData.ettas_data &&
                    briqueData.ettas_data.length > 0 ? (
                      <>
                        <Row className="mt-2">
                          <Col xs={7} className="padding-left-5 print-text">
                            <strong>Ettas</strong>
                          </Col>
                          <Col
                            xs={2}
                            className="d-flex justify-content-center print-text"
                          >
                            <strong>
                              {formatNumberWithCommas(
                                totalSummary.brique_ettas_data_qty
                              )}
                            </strong>
                          </Col>
                          <Col xs={3} className="text-end print-text">
                            <strong>
                              {formatAmount(
                                totalSummary.brique_ettas_data_total
                              )}
                            </strong>
                          </Col>
                        </Row>
                        {briqueData &&
                          briqueData.ettas_data &&
                          briqueData &&
                          briqueData.ettas_data &&
                          briqueData.ettas_data.map((item, index) => {
                            if (index === 0) {
                              globalItemIndex += 7;
                            } else {
                              globalItemIndex += 1;
                            }

                            return (
                              <React.Fragment key={item.name}>
                                {/* {globalItemIndex % 67 === 0 && <br />} */}
                                <Row>
                                  <Col
                                    xs={7}
                                    className="padding-left-7 print-text"
                                  >
                                    {item.name}
                                  </Col>
                                  <Col
                                    xs={2}
                                    className="d-flex justify-content-center print-text"
                                  >
                                    {formatNumberWithCommas(item.total_qty)}
                                  </Col>
                                  <Col xs={3} className="text-end print-text">
                                    {formatAmount(item.total_sales)}
                                  </Col>
                                </Row>
                              </React.Fragment>
                            );
                          })}
                      </>
                    ) : (
                      <Row className="d-flex justify-content-center"></Row>
                    )}

                    {briqueData &&
                    briqueData.brique_data &&
                    briqueData.brique_data.length > 0 ? (
                      <>
                        <Row className="mt-2">
                          <Col xs={7} className="padding-left-5 print-text">
                            <strong>Brique</strong>
                          </Col>
                          <Col
                            xs={2}
                            className="d-flex justify-content-center print-text"
                          >
                            <strong>
                              {formatNumberWithCommas(
                                totalSummary.brique_brique_data_qty
                              )}
                            </strong>
                          </Col>
                          <Col xs={3} className="text-end print-text">
                            <strong>
                              {formatAmount(
                                totalSummary.brique_brique_data_total
                              )}
                            </strong>
                          </Col>
                        </Row>

                        {briqueData &&
                          briqueData.brique_data &&
                          briqueData.brique_data.map((item, index) => {
                            if (index === 0) {
                              globalItemIndex += 2;
                            } else {
                              globalItemIndex += 1;
                            }

                            return (
                              <React.Fragment key={item.name}>
                                <Row>
                                  <Col
                                    xs={7}
                                    className="padding-left-7 print-text"
                                  >
                                    {item.name}
                                  </Col>
                                  <Col
                                    xs={2}
                                    className="d-flex justify-content-center print-text"
                                  >
                                    {formatNumberWithCommas(item.total_qty)}
                                  </Col>
                                  <Col xs={3} className="text-end print-text">
                                    {formatAmount(item.total_sales)}
                                  </Col>
                                </Row>
                              </React.Fragment>
                            );
                          })}

                        {/* {Array.from({ length: 100 }).map((_, i) => (
                            <React.Fragment key={i}>
                              {briqueData &&
                                briqueData.brique_data &&
                                briqueData.brique_data.map((item, index) => {
                                  if (index === 0) {
                                    globalItemIndex += 2;
                                  } else {
                                    globalItemIndex += 1;
                                  }

                                  return (
                                    <React.Fragment key={`${i}-${item.name}`}>
                                      <Row>
                                        <Col xs={7} className="padding-left-7 print-text">
                                          {item.name}
                                        </Col>
                                        <Col
                                          xs={2}
                                          className="d-flex justify-content-center print-text"
                                        >
                                          {formatNumberWithCommas(item.total_qty)}
                                        </Col>
                                        <Col xs={3} className="text-end print-text">
                                          {formatAmount(item.total_sales)}
                                        </Col>
                                      </Row>
                                    </React.Fragment>
                                  );
                                })}
                            </React.Fragment>
                          ))} */}
                      </>
                    ) : (
                      <Row className="d-flex justify-content-center"></Row>
                    )}
                  </div>
                )}
              </div>
            )}
          </Row>
        </Row>
      </div>

      {/* ESCEL REPORT */}
      <div style={{ display: "none" }}>
        <Row>
          <div className="row" ref={csvRef}>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-category">
                {window.company_name}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-category">
                {window.company_address}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-category">
                {window.company_vat_reg_tin}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-category">
                {window.company_min}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-category">
                {window.company_sn}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-category">
                {window.company_ptu_no}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-category">
                {window.issued_date}
              </label>
            </div>
            <table className="table table-bordered left ms-5 ">
              <thead></thead>
              <tbody>
                <tr>
                  <th colSpan={3} className="text-start print-text-category">
                    RESTO ITEM SALES REPORT
                  </th>
                </tr>
                <tr>
                  <th colSpan={3} className="text-start print-text-category">
                    DATE: {dateFormat(new Date(filter.date_from))} -{" "}
                    {dateFormat(new Date(filter.date_to))}
                  </th>
                </tr>
                {/* <tr>
                  <th colSpan={3} className="print-text-category">
                    DATE TO: {dateFormat(new Date(filter.date_to))}
                  </th>
                </tr> */}
                <tr></tr>
                {(filter.menu_location === "ettas" ||
                  filter.menu_location === "" ||
                  !filter.menu_location) && (
                  <>
                    <tr>
                      <td>
                        <strong>Ettas Item Sales</strong>
                      </td>
                      <td className="d-flex justify-content-center">
                        <strong>
                          {formatNumberWithCommas(
                            ettasData?.ettas_item_sales?.qty
                          )}
                        </strong>
                      </td>
                      <td className="text-end">
                        <strong>
                          {formatAmount(
                            ettasData?.ettas_item_sales?.grand_total ?? 0
                          )}
                        </strong>
                      </td>
                    </tr>
                    {ettasData &&
                    ettasData.ettas_data &&
                    ettasData.ettas_data.length > 0 ? (
                      <tr className="my-2">
                        <td className="padding-left-5">
                          <strong>Ettas</strong>
                        </td>
                        <td className="d-flex justify-content-center">
                          <strong>
                            {formatNumberWithCommas(
                              totalSummary.ettas_ettas_data_qty
                            )}
                          </strong>
                        </td>
                        <td className="text-end">
                          <strong className="text-end">
                            {formatAmount(totalSummary.ettas_ettas_data_total)}
                          </strong>
                        </td>
                      </tr>
                    ) : (
                      <tr className="d-flex justify-content-center">
                        NO ETTAS DATA
                      </tr>
                    )}
                    {ettasData &&
                      ettasData.ettas_data &&
                      ettasData.ettas_data.map((item) => (
                        <tr className="" key={item.name}>
                          <td className="padding-left-7">{item.name}</td>
                          <td className="d-flex justify-content-center">
                            {formatNumberWithCommas(item.total_qty)}
                          </td>
                          <td className="text-end">
                            {formatAmount(item.total_sales)}
                          </td>
                        </tr>
                      ))}
                    {ettasData &&
                    ettasData.brique_data &&
                    ettasData.brique_data.length > 0 ? (
                      <tr className="my-2">
                        <td className="padding-left-5">
                          <strong>Brique</strong>
                        </td>
                        <td className="d-flex justify-content-center">
                          <strong>
                            {formatNumberWithCommas(
                              totalSummary.ettas_brique_data_qty
                            )}
                          </strong>
                        </td>
                        <td className="text-end">
                          <strong className="text-end">
                            {formatAmount(totalSummary.ettas_brique_data_total)}
                          </strong>
                        </td>
                      </tr>
                    ) : (
                      <tr className="d-flex justify-content-center">
                        NO BRIQUE DATA
                      </tr>
                    )}
                    {ettasData &&
                      ettasData.brique_data &&
                      ettasData.brique_data.map((item) => (
                        <tr className="" key={item.name}>
                          <td className="padding-left-7">{item.name}</td>
                          <td className="d-flex justify-content-center">
                            {formatNumberWithCommas(item.total_qty)}
                          </td>
                          <td className="text-end">
                            {formatAmount(item.total_sales)}
                          </td>
                        </tr>
                      ))}
                  </>
                )}
                <tr></tr>
                {(filter.menu_location === "happyhippos" ||
                  filter.menu_location === "" ||
                  !filter.menu_location) && (
                  <>
                    <tr>
                      <td>
                        <strong>Brique Item Sales</strong>
                      </td>
                      <td className="d-flex justify-content-center">
                        <strong>
                          {formatNumberWithCommas(
                            briqueData?.brique_item_sales?.qty
                          )}
                        </strong>
                      </td>
                      <td className="text-end">
                        <strong>
                          {formatAmount(
                            briqueData?.brique_item_sales?.grand_total ?? 0
                          )}
                        </strong>
                      </td>
                    </tr>
                    {briqueData &&
                    briqueData.ettas_data &&
                    briqueData.ettas_data.length > 0 ? (
                      <tr className="my-2">
                        <td className="padding-left-5">
                          <strong>Ettas</strong>
                        </td>
                        <td className="d-flex justify-content-center">
                          <strong>
                            {formatNumberWithCommas(
                              totalSummary.brique_ettas_data_qty
                            )}
                          </strong>
                        </td>
                        <td className="text-end">
                          <strong className="text-end">
                            {formatAmount(totalSummary.brique_ettas_data_total)}
                          </strong>
                        </td>
                      </tr>
                    ) : (
                      <tr className="d-flex justify-content-center">
                        NO ETTAS DATA
                      </tr>
                    )}
                    {briqueData &&
                      briqueData.ettas_data &&
                      briqueData.ettas_data.map((item) => (
                        <tr className="" key={item.name}>
                          <td className="padding-left-7">{item.name}</td>
                          <td className="d-flex justify-content-center">
                            {formatNumberWithCommas(item.total_qty)}
                          </td>
                          <td className="text-end">
                            {formatAmount(item.total_sales)}
                          </td>
                        </tr>
                      ))}
                    {briqueData &&
                    briqueData.brique_data &&
                    briqueData.brique_data.length > 0 ? (
                      <tr className="my-2">
                        <td className="padding-left-5">
                          <strong>Brique</strong>
                        </td>
                        <td className="d-flex justify-content-center">
                          <strong>
                            {formatNumberWithCommas(
                              totalSummary.brique_brique_data_qty
                            )}
                          </strong>
                        </td>
                        <td className="text-end">
                          <strong className="text-end">
                            {formatAmount(
                              totalSummary.brique_brique_data_total
                            )}
                          </strong>
                        </td>
                      </tr>
                    ) : (
                      <tr className="d-flex justify-content-center">
                        NO BRIQUE DATA
                      </tr>
                    )}
                    {briqueData &&
                      briqueData.brique_data &&
                      briqueData.brique_data.map((item, index) => (
                        <tr className="" key={index}>
                          <td className="padding-left-7">{item.name}</td>
                          <td className="d-flex justify-content-center">
                            {formatNumberWithCommas(item.total_qty)}
                          </td>
                          <td className="text-end">
                            {formatAmount(item.total_sales)}
                          </td>
                        </tr>
                      ))}
                  </>
                )}

                <tr></tr>
              </tbody>
            </table>
          </div>
        </Row>
      </div>
    </div>
  );
}

export default RestoItemSalesReport;
